export const supportAddressConstant = 'support@hrizer.com'
